/* eslint-disable max-lines */
import { faBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding'
import { faCarSide } from '@fortawesome/pro-solid-svg-icons/faCarSide'
import { faChair } from '@fortawesome/pro-solid-svg-icons/faChair'
import { faIndustry } from '@fortawesome/pro-solid-svg-icons/faIndustry'
import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons/faMobileAlt'
import { faPlane } from '@fortawesome/pro-solid-svg-icons/faPlane'
import { faPlug } from '@fortawesome/pro-solid-svg-icons/faPlug'
import { faQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion'
import { faRulerTriangle } from '@fortawesome/pro-solid-svg-icons/faRulerTriangle'
import { faSyringe } from '@fortawesome/pro-solid-svg-icons/faSyringe'
import { faWrench } from '@fortawesome/pro-solid-svg-icons/faWrench'
import { CategoryItem } from '@/interfaces/categories'
import autodeskIcon from '@/assets/icons/icon-autodesk.svg'
import compressibleIcon from '@/assets/icons/icon-compressible.svg'
import conjugateHeatTransferIcon from '@/assets/icons/icon-conjugate-heat-transfer.svg'
import convectiveHeatTransferIcon from '@/assets/icons/icon-convective-heat-transfer.svg'
import dynamicIcon from '@/assets/icons/icon-dynamic.svg'
import frequencyIcon from '@/assets/icons/icon-frequency.svg'
import harmonicIcon from '@/assets/icons/icon-harmonic.svg'
import heatTransferIcon from '@/assets/icons/icon-heat-transfer.svg'
import immersedBoundaryIcon from '@/assets/icons/icon-immersed-boundary.svg'
import incompressibleIcon from '@/assets/icons/icon-incompressible.svg'
import multiphaseIcon from '@/assets/icons/icon-multiphase.svg'
import onshapeIcon from '@/assets/icons/icon-onshape.svg'
import pedestrianWindComfortIcon from '@/assets/icons/icon-pedestrian-wind-comfort.svg'
import rhinoIcon from '@/assets/icons/icon-rhino.svg'
import solidworksIcon from '@/assets/icons/icon-solidworks.svg'
import staticIcon from '@/assets/icons/icon-static.svg'
import multiPurposeIcon from '@/assets/icons/icon-subsonic.svg'
import thermomechanicalIcon from '@/assets/icons/icon-thermomechanical.svg'
import catiaIcon from '@/assets/icons/icon-catia.svg'
import ptccreoIcon from '@/assets/icons/icon-ptc-creo.svg'
import revitIcon from '@/assets/icons/icon-revit.svg'
import siemensnxIcon from '@/assets/icons/icon-siemens-nx.svg'
import solidedgeIcon from '@/assets/icons/icon-solid-edge.svg'

// TODO: This list might change in the future, because of this ticket: https://simscale.atlassian.net/browse/ENG-38414
export const categoriesData: CategoryItem[] = [
  {
    name: 'AEROSPACE',
    friendlyName: 'Aerospace & Defense',
    description:
      'Aerospace engineers are able to design next-generation aircrafts and parts, optimize safety and comfort of commercial planes, improve fuel efficiency and decrease the negative impact on the environment. Everything with the SimScale cloud-based simulation software.',
    faIcon: faPlane,
    color: '#3d90b4'
  },
  {
    name: 'ARCHITECTURE_CONSTRUCTION',
    friendlyName: 'AEC',
    description:
      'Foresee future circumstances, discover omissions in designs and apply corrections. The SimScale cloud-based simulation platform can be used to test and optimize designs for wind-loading, pedestrian wind comfort, thermal comfort inside buildings and much more.',
    faIcon: faBuilding,
    color: '#FF8700'
  },
  {
    name: 'AUTOMOTIVE',
    friendlyName: 'Automotive & Transportation',
    description:
      'The largest automobile manufacturers in the world have adopted CAE as a compulsory step in their product development process. With SimScale, simulating automobiles, motorcycles, buses, trains, trucks, helicopters, watercraft, spacecraft, or any other vehicle becomes easier than ever before.',
    faIcon: faCarSide,
    color: '#A9A6A6'
  },
  {
    name: 'CONSUMER_PRODUCTS',
    friendlyName: 'Consumer Products',
    description:
      'SimScale supports the simulation of consumer products and parts, as diverse as mobile phones, beverage containers, car seats, racing bikes, and many more, with plenty of different simulation types available.',
    faIcon: faChair,
    color: '#3FABEB'
  },
  {
    name: 'ELECTRONICS',
    friendlyName: 'Electronics & High Tech',
    description:
      'From electronic chips and printed circuit boards (PCBs) to smartphones or computers, SimScale is the perfect tool for electronics simulation, enabling companies to ensure power optimization, durability, efficiency or thermal performance for their products.',
    faIcon: faMobileAlt,
    color: '#2e667f'
  },
  {
    name: 'ENERGY',
    friendlyName: 'Energy',
    description:
      'Enabling energy producers and transportation firms to simulate devices, tools, machinery or storage tanks, computer simulation is playing an important role in testing designs, making repeated changes and increasing overall efficiency in the energy industry.',
    faIcon: faPlug,
    color: '#7b7979'
  },
  {
    name: 'ENGINEERING_SERVICES',
    friendlyName: 'Engineering Services',
    description:
      'Regardless of the industries they are specialized in, engineering offices from all over the world are using the SimScale simulation platform to virtually test their design via a standard Web browser and deliver the best quality to their customers in less time.',
    faIcon: faRulerTriangle,
    color: '#EE4930'
  },
  {
    name: 'INDUSTRIAL_EQUIPMENT',
    friendlyName: 'Machinery & Industrial Equipment',
    description:
      'Perfectly suited for simulating all types of machinery and industrial equipment — with mounting, clamping, adjusting, rotating and other elements, SimScale is used for testing in construction, mining, automotive, chemical, steel and metal.',
    faIcon: faWrench,
    color: '#FFBF00'
  },
  {
    name: 'LIFE_SCIENCE_MEDICAL',
    friendlyName: 'Life Sciences & Healthcare',
    description:
      'With SimScale, innovation within the healthcare industry can be achieved by improving design reliability and more affordable development processes. The platform has a proven track record with the simulation of medical and orthopedic equipment.',
    faIcon: faSyringe,
    color: '#ae3623'
  },
  {
    name: 'MANUFACTURING',
    friendlyName: 'Manufacturing',
    description:
      'Optimized for a wide range of machines, tools and processes, the SimScale cloud-based simulation platform is being used in manufacturing, for a wide range of industry-specific applications.',
    faIcon: faIndustry,
    color: '#60a4c1'
  },
  {
    name: 'MARINE_SHIPBUILDING',
    friendlyName: 'Marine',
    description:
      'Being an integral part of the design process, from concept to production and certifications, CFD simulation and structural analysis are an indispensable tool in the marine industry.',
    faIcon: faMobileAlt,
    color: '#ba762a'
  },

  //  Analysis Type categories
  {
    name: 'COMPRESSIBLE',
    friendlyName: 'Compressible',
    description: 'Find projects using the compressible analysis type here.',
    svgIcon: 'compressible'
  },
  {
    name: 'COUPLED_CONJUGATE_HEAT_TRANSFER',
    friendlyName: 'Conjugate Heat Transfer v2.0',
    description:
      'Conjugate heat transfer v2.0 is a multi-purpose analysis type capable of simulating fluid flow and heat transfer including: solid/fluid conduction, natural or forced convection, and thermal radiation. The solver supports heat sources derived from the Joule heating of electronic circuits and both surface to surface and solar radiation. An arbitrary number of solid and/or fluid regions may be simulated. By solving both the flow fields and heat transfer equations simultaniously, this solver is ideally suited for but not limited to applications such as: electronics cooling, heat exchangers, and HVAC systems. Learn more.',
    svgIcon: 'conjugate-heat-transfer'
  },
  {
    name: 'CONVECTIVE_HEAT_TRANSFER',
    friendlyName: 'Convective Heat Transfer',
    description:
      'This analysis type is used when temperature changes in the fluid lead to density variations and movement of the fluid due to gravity. This solver can be used for natural convection but also for forced convection, when flow motion is induced by external forces, such as inlets, pumps or fans.',
    svgIcon: 'convective-heat-transfer'
  },
  {
    name: 'DYNAMIC',
    friendlyName: 'Dynamic',
    description:
      'This analysis type enables the time-dependent calculation of displacements and stresses in one or more solid bodies. In contrast to a static analysis, in a dynamic analysis phenomena like inertia forces and damping effects can be represented.',
    svgIcon: 'dynamic'
  },
  {
    name: 'FREQUENCY',
    friendlyName: 'Frequency',
    description:
      'The Frequency analysis type is used to calculate the natural frequencies of constrained or free parts and assemblies. Besides the numerical value of the eigenfrequencies, the results provide insights into the deformation behaviour of the corresponding eigenmodes.',
    svgIcon: 'frequency'
  },
  {
    name: 'HARMONIC',
    friendlyName: 'Harmonic',
    description:
      'This analysis type is used to determine the response of a structure under steady-state periodic (sinusoidal) loading at a given range of frequencies.',
    svgIcon: 'harmonic'
  },
  {
    name: 'HEAT_TRANSFER',
    friendlyName: 'Heat Transfer',
    description:
      'This analysis type is used to determine the temperature distribution and heat flux in a solid body. You can choose from several boundary conditions for temperature and heat flux to model the thermal loads in your system.',
    svgIcon: 'heat-transfer'
  },
  {
    name: 'EMBEDDED_BOUNDARY',
    friendlyName: 'Conjugate Heat Transfer (IBM)',
    description:
      'Conjugate heat transfer (IBM) is a very robust method to simulate flow and heat transfer in complex CAD assemblies. It solves the same physics as Conjugate Heat Transfer v2.0 but immerses the CAD parts in a Cartesian background grid (Immersed Boundary Method) avoiding to resolve all parts in an exact way during meshing (body-fitted). It therefore is resilient to undesired details that are insignificant for the overall thermal behavior. It is particularly suited for early stage design studies on complex CAD assemblies like system-level electronics cooling or HVAC applications. Learn more.',
    svgIcon: 'immersed-boundary'
  },
  {
    name: 'INCOMPRESSIBLE',
    friendlyName: 'Incompressible',
    description: 'Find projects using the incompressible analysis type here.',
    svgIcon: 'incompressible'
  },
  {
    name: 'LBM',
    friendlyName: 'Incompressible (LBM)',
    description: 'Find projects using the incompressible pacefish analysis type here.',
    svgIcon: 'incompressible'
  },
  {
    name: 'MULTIPHASE',
    friendlyName: 'Multiphase',
    description:
      'This analysis type is used to simulate the time-dependent behavior of fluid mixtures, for example air and water. The analysis is carried out using the VoF (Volume of Fluid) method which is a standard approach for the computation of multiphase systems.',
    svgIcon: 'multiphase'
  },
  {
    name: 'WIND_COMFORT',
    friendlyName: 'Pedestrian Wind Comfort',
    description: 'Find projects using the PWC analysis type here.',
    svgIcon: 'pedestrian-wind-comfort'
  },
  {
    name: 'STATIC',
    friendlyName: 'Static',
    description:
      'This analysis type is used to determine the displacements and stresses in structures or components caused by the applied constraints and steady loads - inertia and damping effects are ignored. A Static analysis can be either linear or nonlinear.',
    svgIcon: 'static'
  },
  {
    name: 'SIMERICS',
    friendlyName: 'Multi-purpose',
    description:
      'The Multi-purpose analysis type is a proprietary Finite Volume based solver, with a robust binary-tree based meshing strategy and industry validated numerical methods to enable accurate flow and thermal analysis of complex geometries.',
    svgIcon: 'multi-purpose'
  },
  {
    name: 'THERMAL_MECHANICAL',
    friendlyName: 'Thermomechanical',
    description:
      'This analysis type is used to determine the structural and thermal stress of a solid object subjected to thermal and structural loads. First the temperature field is solved and then applied as a load for the structural analysis.',
    svgIcon: 'thermomechanical'
  },
  {
    name: 'ELECTROMAGNETICS',
    friendlyName: 'Electromagnetics',
    description:
      'Simulate complete three-dimensional electromagnetics phenomena including Magnetostatics, Time-Harmonic Magnetics, Electrostatics and Transient Magnetics, with Thermal Coupling. Our electromagnetics offering is under continuous development to support more related problems.',
    spriteIcon: 'electromagnetics'
  },

  //    CAD Formats categories
  {
    name: 'ACIS',
    friendlyName: 'ACIS',
    description: 'Find all public projects containing ACIS CAD models here.',
    svgIcon: 'acis',
    color: '#FF8700'
  },
  {
    name: 'AUTODESK',
    friendlyName: 'Autodesk Inventor',
    description: 'Find all public projects containing Autodesk Inventor CAD models here.',
    svgIcon: 'autodesk',
    color: '#FF8700'
  },
  {
    name: 'CATIA',
    friendlyName: 'Catia',
    description: 'Find all public projects containing Catia CAD models here.',
    svgIcon: 'catia',
    color: '#FF8700'
  },
  {
    name: 'IGES',
    friendlyName: 'IGES',
    description: 'Find all public projects containing IGES CAD models here.',
    svgIcon: 'iges',
    color: '#FF8700'
  },
  {
    name: 'ONSHAPE',
    friendlyName: 'Onshape',
    description: 'Find all public projects containing Onshape CAD models here.',
    svgIcon: 'onshape',
    color: '#FF8700'
  },
  {
    name: 'PARASOLID',
    friendlyName: 'Parasolid',
    description: 'Find all public projects containing Parasolid CAD models here.',
    svgIcon: 'parasolid',
    color: '#FF8700'
  },
  {
    name: 'PTC_CREO',
    friendlyName: 'PTC Creo',
    description: 'Find all public projects containing PTC Creo CAD models here.',
    svgIcon: 'ptc-creo',
    color: '#FF8700'
  },
  {
    name: 'REVIT',
    friendlyName: 'Revit',
    description: 'Find all public projects containing Revit CAD models here.',
    svgIcon: 'revit',
    color: '#FF8700'
  },
  {
    name: 'RHINO',
    friendlyName: 'Rhino',
    description: 'Find all public projects containing Rhino CAD models here.',
    svgIcon: 'rhino',
    color: '#FF8700'
  },
  {
    name: 'SIEMENS_NX',
    friendlyName: 'Siemens NX',
    description: 'Find all public projects containing Siemens NX CAD models here.',
    svgIcon: 'siemens-nx',
    color: '#FF8700'
  },
  {
    name: 'SOLID_EDGE',
    friendlyName: 'Solid Edge',
    description: 'Find all public projects containing Solid Edge CAD models here.',
    svgIcon: 'solid-edge',
    color: '#FF8700'
  },
  {
    name: 'SOLIDWORKS',
    friendlyName: 'SolidWorks',
    description: 'Find all public projects containing SolidWorks CAD models here.',
    svgIcon: 'solidworks',
    color: '#FF8700'
  },
  {
    name: 'STEP',
    friendlyName: 'STEP',
    description: 'Find all public projects containing STEP CAD models here.',
    svgIcon: 'step',
    color: '#FF8700'
  },
  {
    name: 'STL',
    friendlyName: 'STL',
    description: 'Find all public projects containing STL CAD models here.',
    svgIcon: 'stl',
    color: '#FF8700'
  },

  // Other
  {
    name: 'OTHER',
    friendlyName: 'Other',
    description: '',
    faIcon: faQuestion,
    color: '#004563'
  }
]

export const categoriesIconsMap = {
  compressible: compressibleIcon,
  'conjugate-heat-transfer': conjugateHeatTransferIcon,
  dynamic: dynamicIcon,
  'convective-heat-transfer': convectiveHeatTransferIcon,
  frequency: frequencyIcon,
  harmonic: harmonicIcon,
  'heat-transfer': heatTransferIcon,
  'immersed-boundary': immersedBoundaryIcon,
  'pedestrian-wind-comfort': pedestrianWindComfortIcon,
  multiphase: multiphaseIcon,
  incompressible: incompressibleIcon,
  static: staticIcon,
  'multi-purpose': multiPurposeIcon,
  thermomechanical: thermomechanicalIcon,
  onshape: onshapeIcon,
  autodesk: autodeskIcon,
  catia: catiaIcon,
  'ptc-creo': ptccreoIcon,
  revit: revitIcon,
  rhino: rhinoIcon,
  'siemens-nx': siemensnxIcon,
  solidworks: solidworksIcon,
  'solid-edge': solidedgeIcon
}

export const categoriesRedirectionRules = {
  LIGHTING_LED: 'ELECTRONICS',
  OIL_GAS: 'ENERGY',
  PROCESS_PLANT: 'INDUSTRIAL_EQUIPMENT',
  FLUID_FLOW: 'OTHER'
}
